import React from 'react'
import {Routes,Route} from "react-router-dom"
import ContactForm from './ContactForm'
import JobPosts from './JobPosts'
import JobApplication from './JobApplication'
import Jobs from './Jobs'
import Login from './Login'
import Home from './Home'
import Layout from './Layout'

function Navigation() {
  return (
    
    <Routes>
        <Route path="/home" element={<Layout Component={<Home/>}/>}/>
        <Route path="/contact-form" element={<Layout Component={<ContactForm/>}/>}/>
        <Route path="/all-job-posts"  element={<Layout Component={<JobPosts/>}/>}/>
        <Route  path="/job-applications/" element={<Layout Component={<JobApplication/>}/>}/>
        <Route  path="/job-applications/:jobId" element={<Layout Component={<JobApplication/>}/>}/>
        <Route path="/jobs"  element={<Layout Component={<Jobs/>}/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/" element={<Login/>}/>
        
    </Routes>
   
  )
}

export default Navigation